/* eslint-disable */
export default {
  confirmation: 'Bestätigung',
  confirmMergeToConference: 'Zur Telefonkonferenz hinzufügen?',
  mergeToConference: 'Zusammenführen',
  conferenceCall: 'Telefonkonferenz',
} as const;

// @key: @#@"confirmation"@#@ @source: @#@"Confirmation"@#@
// @key: @#@"confirmMergeToConference"@#@ @source: @#@"Add to conference call?"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
